module.exports = __webpack_public_path__ + "media/site_templates/www.roofingcompany.net.au/images/our_services_1-d3cb47a5b4c2a91164f08d070f0da8aa.jpg";